/* eslint-disable import/no-duplicates,no-duplicate-imports,no-unused-vars */
/* global G */
import acl from 'app/_shared/events/acl/component'
import { resolve } from '@gaia/manager/acl/helper'
import { curry } from '@gaia/util'
import session from '@app/_shared/session'
import { back, detail, persistChange, persistScroll, redirect } from '@app/_shared/events'
import toDetailsOrIndex from '@app/_shared/events/redirect/toDetailsOrIndex'
import countActiveDevices from '@app/_shared/events/widget/count/activeDevices'
import countOpenRequests from '@app/_shared/events/widget/count/openRequests'
import countLocations from '@app/_shared/events/widget/count/myLocations'
import countColleagues from '@app/_shared/events/widget/count/contacts'
import soon from '@app/_shared/events/soon'
import fromUserOrgs from 'app/_shared/events/search/query/fromUserOrgs'
import excludeNotConfirmedForRoles from 'app/_shared/events/search/query/excludeNotConfirmedForRoles'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import { chain } from 'app/_shared/events/util'
import persistTab from 'app/_shared/events/tabs/persist'
import remember from 'app/_shared/events/remember'
import platform from 'app/_shared/events/util/platform'
import update from 'app/_shared/events/util/update'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import searchTabsAndRecreate from 'app/_shared/events/appbar/searchTabsAndRecreate'
import mixed, { infiniteMixed } from 'app/_shared/events/search/mixed'
import aggregateDocumentation from 'app/dashboard/event/tdp/aggregateDocumentation'
import searchWith from 'app/_shared/events/search/with'
import global from 'app/_shared/events/search/global'
import action from 'app/_shared/events/action'
import { setLabel } from 'app/_shared/events/tabs/setCountedLabel'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import redirectToSearchOrDetail from 'app/dashboard/event/tdp/redirectToSearchOrDetail'
import isOrganisationOrPersonOrRequestOrServiceItem from 'app/_shared/events/search/query/isOrganisationOrPersonOrRequestOrServiceItem'
import infiniteGlobal from 'app/_shared/events/search/infiniteGlobal'
import withTerm from 'app/_shared/events/search/withTerm'
import mapMeta from 'app/_shared/events/search/mapMeta'
import showMobileApplicationRequiredDialog from 'app/dashboard/event/tdp/showMobileApplicationRequiredDialog'

const self = curry((module, component, event) => {
  // eslint-disable-next-line no-shadow
  const acl = resolve(component)
  let result
  try {
    result = module[G.ADAPTER][G.ACL].check(
      module[G.ADAPTER][G.ACL].get(acl[G.META]),
      acl[G.ACL],
    )
  } catch (e) {
    result = acl[G.PROPS]
  }
  return result
})

export default {
  acl: {
    acl,
    self,
  },
  onOpen: {
    tdpMixedAndAggregate: curry(async (module, component, event) => {
      const result = await mixed(module, component, event)
      const r = result.map(i => ({ ...i, value: { ...i.value, docType: i.value.type, type: undefined } }))
      return aggregateDocumentation(module, component, { ...event, detail: { result: r } })
    }),
    globalWithQuery: chain(
      searchWith(['query']),
      withTerm(mapMeta(global('verbose'))),
    ),
    infiniteGlobal: withTerm(mapMeta(infiniteGlobal('verbose'))),
    infiniteGlobalWithQuery: chain(
      searchWith(['query']),
      withTerm(mapMeta(infiniteGlobal('verbose'))),
    ),
    tdpInfiniteMixedAndAggregate: curry(async (module, component, event) => {
      const result = await infiniteMixed(module, component, event)
      const r = { ...result, data: result.data.map(i => ({ ...i, value: { ...i.value, docType: i.value.type, type: undefined } })) }
      return aggregateDocumentation(module, component, { ...event, detail: { result: r } })
    }),
    tdpInfiniteMixedWithFilterAndAggregate: chain(
      searchWith(['filter']),
      curry(async (module, component, event) => {
        const result = await infiniteMixed(module, component, event)
        const r = { ...result, data: result.data.map(i => ({ ...i, value: { ...i.value, docType: i.value.type, type: undefined } })) }
        return aggregateDocumentation(module, component, { ...event, detail: { result: r } })
      }),
    ),
  },
  onCreate: {
    createRedirect,
  },
  onSearch: {
    noop: (m, c, e) => {},
    searchTabsAndRecreate,
    persistChangeRememberAndRecreate: curry(async (module, component, event) => {
      // We are using field/search here, not a normal input field. It passes its value as term,
      // but all the other event handlers expect value to be present, so we need to add it here.
      const newEvent = { ...event, detail: { ...event.detail, value: event.detail.term } }

      // disabling transition animations for next create

      persistChange(module, component, newEvent)
      await remember(module, component, newEvent)
      await action(module, component, newEvent)

      await module[G.ADAPTER][G.UI].create(module)
    }),
  },
  onClick: {
    toDetailsOrIndex,
    redirectToSearchOrDetail,
    redirect,
    detail,
    soon,
    back,
    redirectWithFocusSearchField: curry(async (module, component, event) => {
      const moduleState = module[G.STATE]
      const { route } = component[G.CONFIGURATION]
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)
      await redirectSequence(module)({ focusSearchField: true })
    }),
    showMobileApplicationRequiredDialog,
  },
  onChange: {
    redirectToSearchOrDetail,
    persistTabAndRemember: chain(
      persistTab,
      remember,
      platform({
        mobile: update,
      }),
    ),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
    remember,
  },
  onPublication: {
    countActiveDevices,
    countOpenRequests,
    countLocations,
    countColleagues,
    noop: curry((module, component, event) => ({ total: { count: null } })),
  },
  onSubscription: {
    own: curry((module, component, event) => session(module)[component[G.PROPS].ref].key()),
  },
  getLabel: {
    setAllLabel: setLabel([], { ns: 'common', key: 'allResults' }),
    setEquipmentLabel: setLabel([], { ns: 'equipmentInformation', key: 'equipment' }),
    setPartsLabel: setLabel([], { ns: 'equipmentInformation', key: 'parts' }),
    setDocumentationLabel: setLabel([], { ns: 'equipmentInformation', key: 'documentation' }),
    setRequestLabel: setLabel([], { ns: 'ticket', key: 'requests' }),
    setOrganisationLabel: setLabel([], { ns: 'organisation', key: 'organisations' }),
    setContactLabel: setLabel([], { ns: 'person', key: 'contacts' }),
    setServiceItemLabel: setLabel([], { ns: 'device', key: 'devices' }),
  },
  getTicketType: {
    listTicketTypes,
  },
  getRequestStatus: {
    listRequestStatus,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  filter: {
    isActive: curry((module, component, event) => ({
      status: { max: 79 },
    })),
    isOpen: curry((module, component, event) => ({
      status: { min: 10, max: 79 },
    })),
    submitter: curry((module, component, event) => ({
      submitter: session(module).user.key({ wrap: true })[0],
    })),
    colleagues: curry((module, component, event) => ({
      id: `!${session(module).person.key({ wrap: true })[0]}`,
    })),
    isOpenAndSubmittedByMe: curry((module, component, event) => ({
      status: { min: 10, max: 79 },
      submitter: session(module).user.key({ wrap: true })[0],
    })),
    isDocumentation: curry((module, component, event) => ({
      type: ['documentation', 'docChunk'],
    })),
    isEquipment: curry((module, component, event) => ({
      type: 'equipment',
    })),
    isArticle: curry((module, component, event) => ({
      type: 'article',
    })),
    isRequest: curry((module, component, event) => ({
      type: 'request',
    })),
  },
  query: {
    userOrgsAsParentOrId: fromUserOrgs('parent', 'id'),
    excludeNotConfirmedForRoles,
    isOrganisationOrPersonOrRequestOrServiceItem,
  },
}
